<template>
<div class="contact">
    <div class="flex">
        <span class="conLab fontSong12">公司总部：</span>
        <a class="conInfo address verdanF12">{{ list.address }}<i class="addressIcon"></i></a>
    </div>
    <div class="flex">
        <span class="conLab fontSong12">电 话：</span>
        <span class="conInfo address verdanF12">{{ list.phone }}</span>
    </div>
    <div class="flex">
        <span class="conLab fontSong12">传 真：</span>
        <span class="conInfo address verdanF12">{{ list.fax }}</span>
    </div>
    <div class="flex">
        <span class="conLab fontSong12">邮 箱：</span>
        <a class="conInfo address verdanF12 underline" :href="`mailto:${list.email}`">{{ list.email }}</a>
    </div>
    <div class="flex">
        <span class="conLab fontSong12">网 址：</span>
        <a class="conInfo address verdanF12 underline" :href="hasHttp(list.web_url)">{{ list.web_url }}</a>
    </div>
    <div class="fontSong12 reaCode">微信公众号：
            <span class="codeMain"
                  @mousemove="mouseOver"
                  @mouseleave="mouseLeave"
            >鼠标移入查看二维码</span>
            <div class="qrCode" v-if="isQRCode" >
                <img class="codeImg" :src="list.miroblog_pic">
                <div>打开微信【扫一扫】</div>
                <div>扫描二维码</div>
            </div>
        </div>
    <!-- <div class="flex">
        <span class="conLab fontSong12">微 信：</span>
        <span class="conInfo address verdanF12" >
            <el-image class="wxImg" :src="weixinImg" style="width: 80px;height: 80px"></el-image>
        </span>
    </div> -->
</div>
</template>

<script>
export default {
    name: "contact",

    props: {
        list: {
            type: Object,
            required: true,
        }
    },
    data(){
        return{
            companyUrl:"https://auction.artron.net/jiade/about/contactUs/",
            weixinImg:'http://img3.artron.net/news/201401/2014010315523758687.jpg',
            isQRCode: false
        }
    },
    methods: {
        mouseOver() {
            this.isQRCode = true;
        },
        mouseLeave() {
            this.isQRCode = false;
        },
        hasHttp(url) {
            const state = url.indexOf('http');
            return state === -1 ? 'http://' + url : url;
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.contact{
    color: #333;
    padding-top: 16px;
    word-wrap: break-word;
    word-break: normal;
    .conLab{
        display: inline-block;
        width: 76px;
        @include color333;
    }
    .conInfo{
        display: inline-block;
        width: 100%;
        font-size: 12px;
        line-height: 22px;
        word-wrap: break-word;
        word-break: break-all;
        @include color333;
        .addressIcon{
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url(../../../assets/imgs/old/address.png) 0 0 no-repeat;
            margin-left: 5px;
        }
    }
    .address:hover{
        .addressIcon{
            background-position: 0 -20px
        }
    }
    .underline{
        text-decoration: underline;
    }
}
.reaCode {
    position: relative;
    .codeMain {
        cursor: pointer;
        &:hover {
            color: rgba(13, 88, 172, 1);
        } 
    }
    .qrCode {
        position: absolute;
        text-align: center;
        width: 150px;
        height: 192px;
        color: rgba(102, 102, 102, 1);
        background-color: #fff;
        /* opacity: 0; */
        .codeImg {
            width: 130px;
            height: 130px;
        }
    }
}
</style>